import wx from 'weixin-js-sdk'
// import jsonp from 'jsonp'
import { getWeixinConfigs } from '@/api/chatbot/index'
export default class WeixinInit {

    constructor() {
        this.wx = wx
        this.teamId = process.env.VUE_APP_DXY_TEAMID
        this.domain = process.env.VUE_APP_OAUTH_DOMAIN
        this.wxConfig = null
    }
    async init() {
        if (window.location.href.includes('alert')) alert('getWeixinConfig')
        return await this.getWeixinConfig()
    }
    async getWeixinConfig() {
        // 传过去的url不能是localhost，不然会报403错误
        let wxSign = false
        try {
            const url = window.location.href;
            const params = {
                url: this.getCurrentUrl(url)
            }
            const res = await getWeixinConfigs(params)
            if (Object.keys(res.data).length > 0 && res.code == 200) {    
                this.wxConfig = res.data.data
                this.initWeixin()
                wxSign = true
            } else {
                console.log("获取微信jsdk失败!")
            }
        } catch (error) {
            console.error(error)
        }
        // window.Vue.$notify({ title: 'DEBUG', message: "wxSign: " + wxSign, duration: 0 })
        return wxSign
    }
    initWeixin() {
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.wxConfig.appid, // 必填，公众号的唯一标识
            timestamp: this.wxConfig.timestamp, // 必填，生成签名的时间戳
            nonceStr: this.wxConfig.noncestr, // 必填，生成签名的随机串
            signature: this.wxConfig.sign, // 必填，签名，见附录1
            jsApiList: [ // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
                'hideOptionMenu', // 隐藏右上角菜单
                'closeWindow',//关闭微信小程序
                'hideToolbar' // 隐藏底部状态栏
            ],
            openTagList: [ // 开放标签列表
                'wx-open-launch-weapp',
            ],
        })
        wx.ready(() => {
            // this.wxShare()
            // wx.hideOptionMenu() // 隐藏右上角菜单
            // wx.hideToolbar();
            // 隐藏右上角菜单和底部工具栏
            if (typeof wx.hideToolbar === 'function') { // 使用 JSSDK 1.4.0 及以上版本
                wx.hideToolbar()
            } else if (typeof wx.hideOptionMenu === 'function') { // 使用早期版本的 JSSDK
                wx.hideOptionMenu()
            }
        })
    }
    getCurrentUrl(url) {
        if (url.includes('?ticket=')) {
            // 如果当前 URL 包含 ?ticket= 参数，就直接返回当前 URL
            return url
        } else {
            // 否则，去掉哈希部分（如果有），再返回拼接后的 URL
            const originPlusPathname = window.location.origin + window.location.pathname;
            return originPlusPathname;
        }
    }
    // closeWindow() {
    //     this.initWeixin((wx)=>{
    //         wx.closeWindow()
    //     })
    // }
}

// export default class weixin {
//   config = {
//     debug: false,
//     appId: 'wxe1be234cd120cbc5',
//     timestamp: 16503439341,
//     nonceStr: '2faa30e0-bfa3-11ec-b758-6d86049319b7',
//     signature: '56bdc7db7906956aca3ccd5086925751665313d9',
//     jsApiList: [
//       'hideOptionMenu',
//       'chooseImage',
//       'previewImage',
//       'uploadImage',
//       'startRecord', //开始录音接口
//       'stopRecord', //停止录音接口
//       'onVoiceRecordEnd', //监听录音自动停止接口
//       'playVoice', //播放语音接口
//       'pauseVoice', //暂停播放接口
//       'stopVoice', //停止播放接口
//       'onVoicePlayEnd', //监听语音播放完毕接口
//       'uploadVoice' //上传语音接口
//     ],
//   }

//   constructor() {
//     this.getJSSDK().then(() => this.init())
//   }

//   // 初始化wx
//   async init() {
//     wx.config({
//       ...this.config,
//     })
//     wx.error((res) => {
//       console.log('error:' + JSON.stringify(res))
//     })
//     wx.ready(() => {
//       wx.hideOptionMenu();
//     })
//   }

//   // 获取js参数
//   async getJSSDK() {
//     try {
//       const params = {
//         url: this.getUrl(),
//         issr: this.getEnv()
//       }
//       const { Result, Data } = await iDoctorApi.getJSSDK(params)
//       if (Result === true) {
//         const { appId, timestamp, nonceStr, signature } = Data
//         this.config.appId = appId
//         this.config.timestamp = timestamp
//         this.config.nonceStr = nonceStr
//         this.config.signature = signature
//       }
//     } catch (error) {
//       console.log(error)
//     }
//   }

//   // 上传图片
//   uploadImg(callback) {
//     wx.chooseImage({
//       count: 1, //默认9
//       sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有 compressed
//       sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有,
//       success: (res) => {
//         const mediaIds = res.localIds //返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
//         wx.uploadImage({
//           localId: mediaIds[0],
//           isShowProgressTips: 1,
//           success: (res) => {
//             callback(res.serverId)
//           },
//           fail: (res) => {
//             Toast.fail({
//               message: '发送图片失败',
//               position: 'top',
//               type: 'html'
//             })
//             console.log(res)
//           }
//         })
//       },
//       fail: function(res) {
//         Toast.fail({
//           message: '发送图片失败',
//           position: 'top',
//           type: 'html'
//         })
//         console.log(res)
//       }
//     })
//   }

//   // 预览图片
//   imgPreview(current, images) {
//     wx.previewImage({
//       current: current,
//       urls: images
//     })
//   }

//   // 开始录音
//   startRecord() {
//     wx.startRecord({
//       success: () => {},
//       cancel: function () {
//         Toast.fail({
//           message: '用户拒绝授权录音',
//           position: 'top',
//           type: 'html'
//         })
//       }
//     });
//   }

//   // 结束录音
//   endRecord(callback) {
//     wx.stopRecord({
//       success: (res) => {
//         const localId = res.localId
//         this.uploadVoice(localId, callback)
//       },
//       fail: () => {
//         Toast.fail({
//           message: '录制失败',
//           position: 'top',
//           type: 'html'
//         })
//       }
//     })
//   }

//   // 取消录音
//   cancelRecord() {
//     wx.stopRecord()
//   }

//   // 播放录音
//   playVoice(localId) {
//     wx.playVoice({
//       localId: localId
//     })
//   }

//   // 暂停播放录音
//   pauseVoice(localId) {
//     wx.pauseVoice({
//       localId: localId // 需要暂停的音频的本地ID，由stopRecord接口获得
//     })
//   }

//   // 上传录音
//   uploadVoice(localId, callback) {
//     wx.uploadVoice({
//       localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
//       isShowProgressTips: 1, // 默认为1，显示进度提示
//       success: function (res) {
//         const serverId = res.serverId // 返回音频的服务器端ID
//         callback(serverId)
//       },
//       fail: function (res) {
//         Toast.fail({
//           message: '录制失败',
//           position: 'top',
//           type: 'html'
//         })
//         console.log(res)
//       }
//     })
//   }

//   getUrl() {
//     return window.location.href.split('#')[0]
//   }

//   getEnv() {
//     const userAgent = window.navigator.userAgent
//     const isWx = /micromessenger/i.test(userAgent) // 是否微信
//     const isComWx = /wxwork/i.test(userAgent) // 是否微信企业端

//     if (isComWx === true) {
//       return true
//     } else if (isWx === true) {
//       return false
//     }
//   }
// }
